import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropSizes(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_sizes/${harvest_process_id}`
    );
  },

  fetchHarvestTeams(organization_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_harvest_teams`
    );
  },

  fetchCropHarPackages(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_har_packages/${harvest_process_id}`
    );
  },

  fetchCropExpPackages(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_exp_packages/${harvest_process_id}`
    );
  },

  destroy(organization_id, harvested_batch_id) {
    return RequesterV1.delete(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/destroy/${harvested_batch_id}`
    );
  },

  fetchHarvestProcess(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_harvest_process/${harvest_process_id}`
    );
  },

  fetchExportedBatch(organization_id, exported_batch_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_exported_batch/${exported_batch_id}`
    );
  },

  update(
    organization_id,
    harvest_process_id,
    exported_batch_id,
    harvested_batch_id,
    harvested_batch
  ) {
    return RequesterV1.post(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/update/${harvest_process_id}/${exported_batch_id}/${harvested_batch_id}`,
      { harvested_batch: harvested_batch }
    );
  },

  fetchProducers(organization_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_producers`
    );
  },

  fetchCropFields(organization_id, harvest_process_id, producer_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_fields/${harvest_process_id}/${producer_id}`
    );
  },

  create(
    organization_id,
    harvest_process_id,
    exported_batch_id,
    harvested_batch
  ) {
    return RequesterV1.post(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/create/${harvest_process_id}/${exported_batch_id}`,
      { harvested_batch: harvested_batch }
    );
  },

  fetchHarvestedBatch(organization_id, harvested_batch_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_harvested_batch/${harvested_batch_id}`
    );
  },

  fetchCropTypes(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_types/${harvest_process_id}`
    );
  },

  fetchCropCategories(organization_id, harvest_process_id) {
    return RequesterV1.get(
      `organization/process/harvest_export/manage_harvested_batch/${organization_id}/fetch_crop_categories/${harvest_process_id}`
    );
  }
};
